import React from 'react'
import { useState } from 'react'

const Leaderboard = ({leaderbaord}) => {

  const [leaderboard, setLeaderBoard] = useState([]) 

  

  return (
    <div className='runs' style={{color: 'white', opacity:"1"}}>
      {leaderbaord.map((player, index) =>(
          <div class='run' style={{display:'flex', justifyContent:'space-between', paddingLeft:"10%", paddingRight:"10%"}}>      
          <h3>#{index + 1}</h3>
          <h3>{player.displayName}</h3>
          <p> {player.highScore}m</p>
      </div>
      ))}   
    </div>
    
  )
}

export default Leaderboard
